import { Target } from '@web-media/event-target';

export const eventTarget = new Target();
